const SheetProcessingLoader = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-4 bg-gray-50">
      <div className="text-center">
        {/* Title and Subtitle Container */}
        <div className="flex flex-col gap-2 w-96">
          {/* Title */}
          <h1 className="font-sans text-2xl font-medium leading-tight text-center text-gray-900">
            Loading your data
          </h1>

          {/* Subtitle */}
          <p className="text-sm font-normal leading-5 text-center text-gray-500">
            Please wait while we process your sheet.
          </p>
          <p className="text-sm font-normal leading-5 text-center text-gray-500">
            This might take up to a minute.
          </p>
        </div>

        {/* Indeterminate Progress Bar */}
        <div className="w-full max-w-xs mx-auto mt-5">
          <div className="relative h-1 overflow-hidden bg-gray-300 rounded-full">
            <div className="absolute top-0 left-0 h-full bg-purple-500 rounded-full animate-indeterminate-progress" style={{ width: '40%' }} />
          </div>
        </div>
        {/* Custom keyframes for indeterminate progress bar */}
        <style>{`
          @keyframes indeterminate-progress {
            0% { left: -40%; }
            100% { left: 100%; }
          }
          .animate-indeterminate-progress {
            animation: indeterminate-progress 1.2s cubic-bezier(0.4,0,0.2,1) infinite;
          }
        `}</style>
      </div>
    </div>
  )
}

export default SheetProcessingLoader